export const FOLLOW_US = 'follow-us';
export const SOCIAL_MEDIA_ICON = 'social-media-icon';
